import React, {  useEffect, useState } from 'react';

const MenuDemo = () => {
  

    return (
        
        <div className="grid">
            <div className='card col-12 md:col-16'>
                <h5 style={{marginLeft:500}}>İletişim</h5>
                <div className='card  flex flex-row'  >
                
                    <div  >
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.581876856707!2d28.781023330157343!3d41.05627191307384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x76e6344516cb873e!2zNDHCsDAzJzIyLjYiTiAyOMKwNDcnMDcuOCJF!5e0!3m2!1str!2str!4v1665401619030!5m2!1str!2str" width="600" height="450" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>

                    <div >
                        <h2 style={{marginLeft:50,marginTop:50}}>İletişim Bilgileri</h2>
                        <h6 style={{marginLeft:70,marginTop:50}}>Adres : Atakent Mahallesi, Atatürk Caddesi No:5/A, Küçükçekmece / İstanbul</h6>
                        <h6 style={{marginLeft:70,marginTop:10}}>Mail  : halkali2etap@gmail.com</h6>
                        <h6 style={{marginLeft:70,marginTop:10}}>İş No  : 0(212) 697 20 79</h6>
                        <h6 style={{marginLeft:70,marginTop:10}}>İş No2  : 0(212) 697 10 82</h6>
                        <h6 style={{marginLeft:70,marginTop:10}}>Cep No  : 0(532) 214 30 08</h6>
                    </div>
                </div>
            </div>
            
            
            
        </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(MenuDemo, comparisonFn);